import { memo, useCallback } from 'react';
import { Link } from '@amzn/awsui-components-core';

import { useToolbarActionService } from '../../contexts/ToolbarActionServiceContext';
import { InfoPaneTopicId } from '../../services/ToolbarActionService';

interface PatternSectionInfoLinkProps {
  /** Help topic to open in the info pane when the link is followed. */
  readonly topicId: InfoPaneTopicId;
}

/** Cloudscape "Info" link that opens the info pane to `topicId`. */
export const PatternSectionInfoLink = memo(function PatternSectionInfoLink({
  topicId,
}: PatternSectionInfoLinkProps) {
  const toolbarService = useToolbarActionService();

  const openInfoPane = useCallback(() => {
    toolbarService.changeInfoPaneTopic(topicId, undefined);
    toolbarService.activePanel = 'info';
  }, [toolbarService, topicId]);

  return (
    <Link variant="info" onFollow={openInfoPane}>
      Info
    </Link>
  );
});
